export { default } from './TravelGuideTeaserExtended'
